import type { DashboardUser } from '../auth/auth-adapter'
import { getEnvironment } from '../../lib/environment'
import { createApiClient } from '../../services/api/client'
import {
  smsActivityPageSchema,
  type SmsActivityPage,
} from './sms-activity-contracts'

export type SmsActivityRepository = {
  list: (
    tenantId: string,
    cursor?: string,
    signal?: AbortSignal
  ) => Promise<SmsActivityPage>
}

export function createSmsActivityRepository({
  getUser,
  baseUrl = getEnvironment().userManagementBaseUrl,
  fetchImplementation = fetch,
}: {
  getUser: () => DashboardUser | null
  baseUrl?: string
  fetchImplementation?: typeof fetch
}): SmsActivityRepository {
  const client = createApiClient({ baseUrl, getUser, fetchImplementation })
  return {
    list(tenantId, cursor, signal) {
      const query = new URLSearchParams({ pageSize: '25', contextVersion: '2' })
      if (cursor) query.set('cursor', cursor)
      return client.request(
        `/dashboard/clinics/${encodeURIComponent(tenantId)}/automated-sms-activity?${query}`,
        { method: 'GET', signal, responseSchema: smsActivityPageSchema }
      )
    },
  }
}
